import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // You can also log the error to an error reporting service
    console.error("Uncaught error:", error, errorInfo);
    this.setState({ error, errorInfo });
  }

  render() {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      // In development, it's useful to show the error directly.
      if (import.meta.env.VITE_NODE_ENV === 'development') {
        return (
          <div style={{ padding: '2rem', backgroundColor: '#fff1f2', color: '#ef4444', height: '100vh' }}>
            <h1 style={{ fontSize: '1.5rem', fontWeight: 'bold' }}>Something went wrong.</h1>
            <p>This message is shown only in development.</p>
            <details style={{ whiteSpace: 'pre-wrap', marginTop: '1rem', background: '#fef2f2', padding: '1rem', borderRadius: '0.5rem' }}>
              <summary style={{ cursor: 'pointer', fontWeight: 'bold' }}>Error Details</summary>
              {this.state.error && this.state.error.toString()}
              <br />
              {this.state.errorInfo && this.state.errorInfo.componentStack}
            </details>
            <button
              onClick={() => window.location.assign('/')}
              style={{
                marginTop: '1.5rem',
                padding: '0.5rem 1rem',
                border: '1px solid #ef4444',
                borderRadius: '0.25rem',
                backgroundColor: '#ef4444',
                color: 'white',
                cursor: 'pointer'
              }}
            >
              Go to Homepage
            </button>
          </div>
        );
      }

      // In production, show a user-friendly message.
      return (
        <div style={{ padding: '2rem', textAlign: 'center', height: '100vh' }}>
          <h1>Oops! Something went wrong.</h1>
          <p>We're sorry for the inconvenience. Please try refreshing the page or go back home.</p>
          <a href="/">Go to Homepage</a>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;